import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    md: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    xs: [
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        from_date: null,
        to_date: null,
    },
    components: [
        {
            name: 'documents-storage-file-upload',
            key: 'c1',

            props: {
                accept: {
                    normal: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,text/csv,image/jpeg,image/png,image/jpg,application/pdf,application/xml,text/xml',
                    anonymization: 'application/pdf',
                },
                placeholder: {
                    normal: 'ui.mm.drop-files-details',
                    anonymization:
                        'ui.mm.anonymize-upload-only.drop-files-details',
                },
            },
        },
    ],
};
